import { useQuery } from '@tanstack/react-query';

import { getOrderDetailById } from 'shared/infra';
import { qkGetOrderDetailById } from './queryKeys';

import { ORDER_DETAIL_MODEL_INIT } from 'shared/domain';

import type { OrderId } from 'shared/domain';

export function useGetOrderDetailById(orderId: OrderId) {
  const _useQuery = useQuery({
    queryKey: qkGetOrderDetailById(orderId),
    queryFn: () => getOrderDetailById(orderId),
    enabled: !!orderId,
  });
  return {
    ..._useQuery,
    data: _useQuery.data ?? ORDER_DETAIL_MODEL_INIT,
  };
}
